export const LIST_ENTITIES = `
  query ListEntities($entityName: String!, $filter: AWSJSON) {
    listEntities(entityName: $entityName, filter: $filter)
  }
`;

export const GET_ENTITY = `
  query GetEntity($entityName: String!, $id: String!) {
    getEntity(entityName: $entityName, id: $id)
  }
`;
